{
  "close": "Zatvoriť"
}
